import React, { useState } from "react";
import { ShoppingCart, Plus, Minus, X } from "lucide-react";

const PolloFelizMenu = () => {
    const [cart, setCart] = useState([]);
    const [cartOpen, setCartOpen] = useState(false);

    const menuItems = [
        // PAQUETES
        {
            id: 1,
            category: "PAQUETES",
            name: "POLLO ENTERO",
            subtitle: "8 PIEZAS",
            description: "1 ORDEN DE: TORTILLAS, FRIJOLES, SALSA, TOTOPOS, CHILES, Y CEBOLLAS ASADAS",
            image: "https://images.rappi.com.mx/products/3083f72b-0705-4e1d-9c65-50490c56e77b.png?e=webp&q=50&d=400x400",
            price: 180,
            featured: true
        },
        {
            id: 2,
            category: "PAQUETES",
            name: "MEDIO POLLO",
            subtitle: "4 PIEZAS",
            description: "1 ORDEN DE: TORTILLAS, FRIJOLES, SALSA, TOTOPOS, CHILES, Y CEBOLLAS ASADAS",
            image: "https://images.rappi.com.mx/products/3083f72b-0705-4e1d-9c65-50490c56e77b.png?e=webp&q=50&d=400x400",
            price: 95,
            featured: true
        },
        // ENTRADAS
        {
            id: 3,
            category: "ENTRADAS",
            name: "ORDEN DE FLAUTAS",
            description: "10 DELICIOSAS FLAUTAS RELLENAS DE POLLO FELIZ",
            image: "https://images.rappi.com.mx/products/fcd1a048-e8d7-40fe-97ff-66bddd859ef6.png?e=webp&q=50&d=400x400",
            price: 85
        },
        {
            id: 4,
            category: "ENTRADAS",
            name: "ORDEN DE NUGGETS",
            subtitle: "(150G.)",
            description: "8 NUGGETS CON UNA ORDEN DE PAPAS A LA FRANCESA",
            image: "https://images.rappi.com.mx/products/f932f7e9-38e9-4be3-b557-9aa5f71be59e.png?e=webp&q=50&d=400x400",
            price: 95
        },
        {
            id: 5,
            category: "ENTRADAS",
            name: "QUESADILLA GIGANTE",
            description: "ELABORADA CON NUESTRO QUESO ESPECIAL EN TORTILLA DE MAÍZ RECIÉN HECHA",
            image: "https://images.rappi.com.mx/products/5b8d546b-2492-4007-b0db-dc0ced62600e.png?e=webp&q=50&d=400x400",
            price: 75
        },
        // PARA ACOMPAÑAR
        {
            id: 6,
            category: "PARA ACOMPAÑAR",
            name: "ARROZ A LA MEXICANA",
            description: "LA TRADICIONAL RECETA DE NUESTRA COCINA, SAZONADO CON INGREDIENTES NATURALES.",
            image: "https://placehold.co/400x300/FFBC00/FF0000?text=Arroz",
            price: 35
        },
        {
            id: 7,
            category: "PARA ACOMPAÑAR",
            name: "SOPA FRÍA",
            description: "DELICIOSA SOPA FRIA",
            image: "https://placehold.co/400x300/FFBC00/FF0000?text=Sopa+Fria",
            price: 30
        },
        {
            id: 8,
            category: "PARA ACOMPAÑAR",
            name: "PAPAS A LA FRANCESA",
            subtitle: "(250G.)",
            description: "COCINADAS AL MOMENTO CON UNA PIZCA DE SAL",
            image: "https://placehold.co/400x300/FFBC00/FF0000?text=Papas",
            price: 40
        },
        // BEBIDAS
        {
            id: 9,
            category: "BEBIDAS",
            name: "REFRESCO 600ML",
            description: "COCA-COLA, SPRITE, FANTA",
            image: "https://images.rappi.com.mx/products/b9da0bda-6f02-4cd0-b5f5-1d14f829886b.jpg?e=webp&q=50&d=400x400",
            price: 25
        },
        {
            id: 10,
            category: "BEBIDAS",
            name: "AGUA FRESCA 1L",
            description: "JAMAICA, HORCHATA, LIMÓN",
            image: "https://placehold.co/400x300/FFBC00/FF0000?text=Agua+Fresca",
            price: 30
        }
    ];

    const categories = [
        { name: "PAQUETES", bg: "#FF0000" },
        { name: "ENTRADAS", bg: "#FFBC00" },
        { name: "PARA ACOMPAÑAR", bg: "#FFBC00" },
        { name: "BEBIDAS", bg: "#FFBC00" }
    ];

    const addToCart = (item) => {
        const existingItem = cart.find(cartItem => cartItem.id === item.id);
        if (existingItem) {
            setCart(cart.map(cartItem =>
                cartItem.id === item.id
                    ? { ...cartItem, quantity: cartItem.quantity + 1 }
                    : cartItem
            ));
        } else {
            setCart([...cart, { ...item, quantity: 1 }]);
        }
    };

    const updateQuantity = (id, delta) => {
        setCart(cart.map(item =>
            item.id === id
                ? { ...item, quantity: Math.max(0, item.quantity + delta) }
                : item
        ).filter(item => item.quantity > 0));
    };

    const getTotalPrice = () => {
        return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
    };

    const getTotalItems = () => {
        return cart.reduce((total, item) => total + item.quantity, 0);
    };

    return (
        <div className="min-h-screen bg-[#FFBC00] pt-24 pb-8">
            <div className="max-w-7xl mx-auto px-4">
                {/* Header */}
                <div className="mb-8 text-center">
                    <div className="inline-block border-4 border-[#FF0000] px-8 py-4 mb-6 bg-[#FFBC00]">
                        <img
                            src="https://firebasestorage.googleapis.com/v0/b/newpollofeliz.appspot.com/o/LogoPolloApp.png?alt=media&token=90a9888b-5da9-4e01-9f45-1c6a19cd9cf1"
                            alt="Pollo Feliz"
                            className="h-32 mx-auto mb-2"
                        />
                        <h1 className="text-5xl md:text-6xl font-black text-[#FF0000] tracking-wider">
                            MENÚ
                        </h1>
                    </div>
                </div>

                {/* Promo Banner - Miércoles */}
                <div className="mb-8 bg-[#FF0000] border-4 border-[#FF0000] rounded-lg p-6 shadow-xl">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center gap-4">
                            <div className="bg-white rounded-full p-4 border-4 border-[#FFBC00]">
                                <span className="text-5xl">🤘</span>
                            </div>
                            <div>
                                <p className="text-3xl font-black text-[#FFBC00] tracking-wide">
                                    TODOS LOS MIÉRCOLES
                                </p>
                                <p className="text-xl font-bold text-white">
                                    EN LA COMPRA DE UN POLLO A PRECIO REGULAR
                                </p>
                            </div>
                        </div>
                        <div className="text-right">
                            <p className="text-5xl font-black text-white tracking-wide">
                                1/2 POLLO
                            </p>
                            <p className="text-4xl font-black text-[#FFBC00]">GRATIS</p>
                        </div>
                    </div>
                </div>

                {/* Categories and Items */}
                {categories.map((category, idx) => {
                    const categoryItems = menuItems.filter(item => item.category === category.name);
                    if (categoryItems.length === 0) return null;

                    return (
                        <div key={idx} className="mb-10">
                            {/* Category Header */}
                            <div
                                className="border-4 border-[#FF0000] mb-6 py-3 px-6 inline-flex items-center gap-3"
                                style={{ backgroundColor: category.bg }}
                            >
                                <img
                                    src="https://firebasestorage.googleapis.com/v0/b/newpollofeliz.appspot.com/o/LogoPolloApp.png?alt=media&token=90a9888b-5da9-4e01-9f45-1c6a19cd9cf1"
                                    alt="Pollo"
                                    className="h-12"
                                />
                                <h2 className="text-3xl font-black text-[#FF0000] tracking-wide">
                                    {category.name}
                                </h2>
                            </div>

                            {/* Menu Items Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {categoryItems.map(item => (
                                    <div
                                        key={item.id}
                                        className={`bg-[#F5EBDD] border-3 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-1 ${item.featured ? 'border-[#FF0000] border-4' : 'border-[#FF0000]'
                                            }`}
                                    >
                                        {/* Image */}
                                        <div className="relative aspect-square bg-white overflow-hidden">
                                            <img
                                                src={item.image}
                                                alt={item.name}
                                                className="w-full h-full object-cover"
                                            />
                                            {item.featured && (
                                                <div className="absolute top-2 right-2 bg-[#FF0000] text-white px-3 py-1 rounded-full text-xs font-bold">
                                                    POPULAR
                                                </div>
                                            )}
                                        </div>

                                        {/* Content */}
                                        <div className="p-4">
                                            <h3 className="text-xl font-black text-[#FF0000] tracking-wide leading-tight">
                                                {item.name}
                                            </h3>
                                            {item.subtitle && (
                                                <p className="text-lg font-bold text-[#FF0000] mb-2">
                                                    {item.subtitle}
                                                </p>
                                            )}
                                            <p className="text-sm text-[#000000] mb-3 leading-snug">
                                                {item.description}
                                            </p>

                                            {/* Price and Add Button */}
                                            <div className="flex items-center justify-between mt-3">
                                                <span className="text-2xl font-black text-[#FF0000]">
                                                    ${item.price}
                                                </span>
                                                <button
                                                    onClick={() => addToCart(item)}
                                                    className="bg-[#FF0000] text-white px-4 py-1.5 rounded-lg font-bold uppercase tracking-wide hover:bg-[#000000] transition-all border-2 border-[#FF0000] hover:border-[#000000] flex items-center gap-1 text-sm"
                                                >
                                                    <Plus className="w-4 h-4" />
                                                    Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Extras Note for Paquetes */}
                            {category.name === "PAQUETES" && (
                                <div className="mt-4 bg-[#FF0000] border-2 border-[#FF0000] p-3 rounded-lg">
                                    <p className="text-white font-bold text-sm">
                                        <span className="font-black">EXTRAS:</span> TORTILLAS, FRIJOLES, SALSA, TOTOPOS, CHILES, Y CEBOLLAS ASADAS
                                    </p>
                                </div>
                            )}
                        </div>
                    );
                })}

                {/* Floating Cart Button */}
                {cart.length > 0 && (
                    <button
                        onClick={() => setCartOpen(true)}
                        className="fixed bottom-6 right-6 bg-[#FF0000] text-white p-4 rounded-full shadow-2xl hover:bg-[#000000] transition-all border-4 border-white z-50"
                    >
                        <ShoppingCart className="w-8 h-8" />
                        <span className="absolute -top-2 -right-2 bg-[#FFBC00] text-[#FF0000] w-8 h-8 rounded-full flex items-center justify-center font-bold border-2 border-white text-sm">
                            {getTotalItems()}
                        </span>
                    </button>
                )}

                {/* Cart Modal */}
                {cartOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                        <div className="bg-[#F5EBDD] border-4 border-[#FF0000] rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col">
                            {/* Header */}
                            <div className="bg-[#FF0000] p-6 flex items-center justify-between">
                                <h2 className="text-3xl font-black text-white tracking-wide">
                                    TU ORDEN
                                </h2>
                                <button
                                    onClick={() => setCartOpen(false)}
                                    className="text-white hover:text-[#FFBC00] transition-colors"
                                >
                                    <X className="w-8 h-8" />
                                </button>
                            </div>

                            {/* Cart Items */}
                            <div className="flex-1 overflow-y-auto p-6">
                                {cart.map(item => (
                                    <div
                                        key={item.id}
                                        className="bg-white border-2 border-[#FF0000] rounded-lg p-4 mb-4 flex items-center justify-between"
                                    >
                                        <div className="flex-1">
                                            <h3 className="text-lg font-black text-[#FF0000]">
                                                {item.name}
                                            </h3>
                                            <p className="text-[#000000] font-bold text-sm">
                                                ${item.price} c/u
                                            </p>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <button
                                                onClick={() => updateQuantity(item.id, -1)}
                                                className="bg-[#FF0000] text-white w-8 h-8 rounded-lg flex items-center justify-center hover:bg-[#000000] transition-all"
                                            >
                                                <Minus className="w-4 h-4" />
                                            </button>
                                            <span className="text-2xl font-black text-[#FF0000] w-8 text-center">
                                                {item.quantity}
                                            </span>
                                            <button
                                                onClick={() => updateQuantity(item.id, 1)}
                                                className="bg-[#FF0000] text-white w-8 h-8 rounded-lg flex items-center justify-center hover:bg-[#000000] transition-all"
                                            >
                                                <Plus className="w-4 h-4" />
                                            </button>
                                            <span className="text-xl font-black text-[#FF0000] ml-4 w-20 text-right">
                                                ${item.price * item.quantity}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Footer */}
                            <div className="bg-[#FF0000] p-6">
                                <div className="flex justify-between items-center mb-4">
                                    <span className="text-2xl font-black text-white">TOTAL:</span>
                                    <span className="text-4xl font-black text-[#FFBC00]">
                                        ${getTotalPrice()}
                                    </span>
                                </div>
                                <button className="w-full bg-[#FFBC00] text-[#FF0000] py-4 rounded-lg font-black text-xl uppercase tracking-wide hover:bg-white transition-all border-2 border-[#FFBC00]">
                                    ORDENAR AHORA
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PolloFelizMenu;